const Spinner = () => (
  <div className="w-5 h-5 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
);

export default Spinner;
